module.exports = __webpack_public_path__ + "img/TPB.5c303971.png";